<script setup>
import { twMerge } from "tailwind-merge";
import Modal from "./Modal.vue";

const emit = defineEmits(["close"]);

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: "2xl",
  },
  closeable: {
    type: Boolean,
    default: true,
  },
  titleClass: {
    type: String,
    default: '',
  },
  contentClass: {
    type: String,
    default: '',
  }
});

const close = () => {
  emit("close");
};
</script>

<template>
  <Modal
    :show="show"
    :max-width="maxWidth"
    :closeable="closeable"
    @close="close"
  >
    <div :class="twMerge('px-6 py-4', titleClass)">
      <div class="text-start text-lg font-medium text-gray-900">
        <slot name="title" />
      </div>

      <div :class="twMerge('mt-4 text-sm text-gray-600', contentClass)">
        <slot name="content" />
      </div>
    </div>

    <div class="flex flex-row justify-end px-6 py-4 text-right">
      <slot name="footer" />
    </div>
  </Modal>
</template>
